import { PATH_LOGIN } from "@/routes/paths";
import { useAuthStore } from "@/store/auth/auth.store";
import { useCallCentersStore } from "@/store/call-centers/call-centers.store";
import { useState } from "react";
import { Navigate, useNavigate } from "react-router-dom";
import { DeleteConfirmationModal } from "@/components/DeleteConfirmationModal"; 
const Logout = () => {
  const navigate = useNavigate();
  const isLoggedIn = useAuthStore((s) => s.isLoggedIn);
  const [isLoggingOut, setIsLoggingOut] = useState(false);

  const handleConfirm = async () => {
    setIsLoggingOut(true);
    useAuthStore.getState().logout();
    // Stores are independent — clear session-scoped ones explicitly.
    useCallCentersStore.getState().reset();
    setIsLoggingOut(false);
  };

  const handleClose = () => {
    navigate(-1);
  };

  if (!isLoggedIn) return <Navigate to={PATH_LOGIN} replace />;

  return (
    <DeleteConfirmationModal
      open={true}
      onClose={handleClose}
      onConfirm={handleConfirm}
      title="Are you sure you want to logout?"
      confirmButtonText="Yes, Logout"
      isDeleting={isLoggingOut}
    />
  );
};

export default Logout;
